import React, { useEffect, useState } from 'react';

// PROPTYPES
import { Link } from 'react-router-dom';
import { Menu, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import withTranslations from 'app/components/HOGs/withTranslations';
import { applyingTypes } from 'app/constants/folder.constants';
// ROUTER
import pageCache from 'app/API/cache.service';

// COMPONENT
import { fetchFolders } from 'actions/Menu/folders-async.actions';
import folder_add from 'static/img/folder/folder_gray.svg';
import SwitchMapList from '../SwitchMapandList/switch';
import FriendsSelect from './components/selectFriend';
import FolderList, { getFolderListCollapse } from './Folders/FolderList';
import SocialBtn from './components/socialBtn';
import CollapseBtn from './components/collapseBtn';
// SVG
import {
  BikerBedIcon,
  MoreIcon,
  BikerClubIcon,
  ToursIcon,
  MyToursIcon,
  FriendToursIcon,
  PlacesIcon,
  TrackIcon,
  MemberIcon,
  ProIcon,
  DreamTour,
  NafIcon,
} from './svg';
import { ButtonStarIcon } from '../TourstartAcademy/academy.svg';

// CSS
import './menu.css';

// CONSTANT
import TourCounter from './Folders/tourCounter';
import PlaceCounter from './Folders/placeCounter';

const CreateFolder = 'createFolder';

const allIcon = {
  home: <DreamTour height="19px" width="19px" />,
  naf: <NafIcon height="19px" width="19px" />,
  tours: <ToursIcon height="19px" width="19px" />,
  mytours: <MyToursIcon height="19px" width="19px" />,
  friendtours: <FriendToursIcon height="19px" width="19px" />,
  places: <PlacesIcon height="19px" width="19px" />,
  track: <TrackIcon height="18px" width="18px" />,
  bikerclub: <BikerClubIcon height="18px" width="18px" />,
  bikerbed: <BikerBedIcon height="19px" width="19px" />,
  members: <MemberIcon height="17px" width="17px" />,
  pro: <ProIcon height="21px" width="21px" />,
  academy: <ButtonStarIcon height="18px" width="18px" />,
  more: <MoreIcon height="18px" width="18px" />,
}; // MENU ICON

const getLink = (link, id) =>
  id === '1' ||
  id === '3' ||
  id === '4' ||
  id === '6' ||
  id === '9' ||
  id === '10' ||
  id === '13' ||
  id === '15' ||
  id === '16' ||
  id === '17' ||
  id === '20' ||
  id === '21'
    ? `${link}/list`
    : link;

export function createSubMenu(data, props) {
  const {
    disabled,
    authUserData,
    selectedKeys,
    collapse,
    isMobile,
    tr,
    folders,
    addFolderVisible,
    setAddFolderVisible,
    foldersPlace,
    folderPlacesCount,
    myPlacesCount,
  } = props;
  const items = [];

  data.forEach((item) => {
    if (item.visible === 0) {
      return;
    }

    if (item.id === '33') {
      items.push({
        label: (
          <FolderList
            isAddFolder={addFolderVisible}
            hideAddFolderMenu={() => setAddFolderVisible(false)}
            authUser={authUserData}
            active={selectedKeys?.includes('33')}
            collapsed={collapse}
            isMobile={isMobile}
            applying={applyingTypes.DENMARK_FOLDER}
          />
        ),
        key: item.id,
        className: 'folder-menu-wrapper dream',
      });
      return;
    }

    if (item.id === '35') {
      items.push({
        label: (
          <FolderList
            isAddFolder={addFolderVisible}
            hideAddFolderMenu={() => setAddFolderVisible(false)}
            authUser={authUserData}
            active={selectedKeys?.includes('35')}
            collapsed={collapse}
            isMobile={isMobile}
            applying={applyingTypes.FRANCE_FOLDER}
          />
        ),
        key: item.id,
        className: 'folder-menu-wrapper dream',
      });
      return;
    }

    if (item.id === '37') {
      items.push({
        label: (
          <FolderList
            isAddFolder={addFolderVisible}
            hideAddFolderMenu={() => setAddFolderVisible(false)}
            authUser={authUserData}
            active={selectedKeys?.includes('37')}
            collapsed={collapse}
            isMobile={isMobile}
            applying={applyingTypes.GERMANY_FOLDER}
          />
        ),
        key: item.id,
        className: 'folder-menu-wrapper dream german',
      });
      return;
    }

    if (item.id === '38') {
      items.push({
        label: (
          <Link to="/dreamtours/naf/list" draggable={false}>
            <FormattedMessage id={item.title} defaultMessage={item.title} />
            <NafIcon height="18px" width="18px" />
          </Link>
        ),
        key: item.id,
        className: `custom-${item.title
          .split(' ')
          .join('-')
          .toLocaleLowerCase()}`,
      });
      return;
    }
    if (item.id === '5' && !collapse) {
      items.push({
        label: (
          <FolderList
            isAddFolder={addFolderVisible}
            hideAddFolderMenu={() => setAddFolderVisible(false)}
            authUser={authUserData}
            active={selectedKeys?.includes('5')}
            collapsed={collapse}
            isMobile={isMobile}
            applying={applyingTypes.TOUR_FOLDER}
          />
        ),
        key: item.id,
        className: 'folder-menu-wrapper',
      });
      return;
    }

    if (item.id === '5' && collapse && folders.length > 0) {
      items.push({
        label: <FormattedMessage id={item.title} defaultMessage={item.title} />,
        key: item.id,
        className: 'mainSubMenuMenu submenu-folders-list',
        children: getFolderListCollapse(
          applyingTypes.TOUR_FOLDER,
          isMobile,
          folders
        ),
      });
      return;
    }

    if (item.id === '5' && collapse && folders.length === 0) {
      return;
    }

    if (item.id === '11' && !collapse) {
      items.push({
        label: (
          <FolderList
            isAddFolder={addFolderVisible}
            hideAddFolderMenu={() => setAddFolderVisible(false)}
            authUser={authUserData}
            active={selectedKeys?.includes('11')}
            collapsed={collapse}
            isMobile={isMobile}
            applying={applyingTypes.PLACE_FOLDER}
          />
        ),
        key: item.id,
        className: 'folder-menu-wrapper',
      });
      return;
    }

    if (item.id === '11' && collapse && foldersPlace.length > 0) {
      items.push({
        label: <FormattedMessage id={item.title} defaultMessage={item.title} />,
        key: item.id,
        className: 'mainSubMenuMenu submenu-folders-list',
        children: getFolderListCollapse(
          applyingTypes.PLACE_FOLDER,
          isMobile,
          foldersPlace
        ),
      });
      return;
    }

    if (item.id === '11' && collapse && foldersPlace.length === 0) {
      return;
    }

    items.push({
      label: (
        <span className="span">
          <Link to={getLink(item.url, item.id)} draggable={false}>
            <span className="menu-item-title">
              <FormattedMessage id={item.title} defaultMessage={item.title} />
            </span>
          </Link>
          {authUserData?.id && item.id === '10' ? (
            <PlaceCounter
              count={
                myPlacesCount - folderPlacesCount > 0
                  ? myPlacesCount - folderPlacesCount
                  : 0
              }
            />
          ) : null}
          {item.createFolder && !collapse && authUserData?.id ? (
            <Tooltip title={tr['Create folder']}>
              <img
                src={folder_add}
                alt=""
                className={CreateFolder}
                onClick={disabled ? null : () => setAddFolderVisible(true)}
                aria-hidden
              />
            </Tooltip>
          ) : null}
        </span>
      ),
      key: item.id,
      icon: !collapse ? allIcon[item.icon] : null,
      className: `custom-${item.title
        .split(' ')
        .join('-')
        .toLocaleLowerCase()}`,
    });
  });
  return items;
}
export const createMenu = (data, props) => {
  const dispatch = useDispatch();
  const [addFolderVisible, setAddFolderVisible] = useState(false);
  const folders = useSelector((store) => store.folders);
  const folderTours = folders.map(({ tours }) => tours).flat();
  const folderToursCount = folderTours.filter(
    (folder, index) => folderTours.indexOf(folder) === index
  ).length;
  const foldersPlace = useSelector((store) => store.foldersPlace);
  const folderPlaces = foldersPlace.map(({ tours }) => tours).flat();
  const folderPlacesCount = folderPlaces.filter(
    (folder, index) => folderPlaces.indexOf(folder) === index
  ).length;

  const myPlacesCount = useSelector((store) => store.counter.myPlaces);
  const myToursCount =
    useSelector((store) => store.counter.myTours) || 'loading';

  const folderCreateVisible = useSelector(
    (store) => store.mainMenuData.folder_create_visible
  );

  const tourCounterMain =
    myToursCount - folderToursCount > 0 ? myToursCount - folderToursCount : 0;

  const folderListDenmark = pageCache.get('dreamFolders')?.Denmark || [];
  const folderListFrance = pageCache.get('dreamFolders')?.France || [];
  const folderListGermany = pageCache.get('dreamFolders')?.Germany || [];

  const getArrowClass = props.openMyFolders
    ? 'ant-menu-submenu-arrow my'
    : 'ant-menu-submenu-arrow my open';

  const getDreamArrowClass = props.openDreamFolders
    ? 'ant-menu-submenu-arrow my'
    : 'ant-menu-submenu-arrow my open';

  useEffect(() => {
    if (folderCreateVisible) {
      props.openMyFoldersFc(true);
      setAddFolderVisible(true);
    }
  }, [folderCreateVisible]);

  useEffect(() => {
    if (props.isLoggedIn && props.authUserData) {
      const userId = props.authUserData.id || 0;
      dispatch(fetchFolders(userId));
    }
  }, [props.isLoggedIn]);

  const items = [];

  data.forEach((item) => {
    if (item.visible) {
      data = {
        label: (
          <Link to={getLink(item.url, item.id)}>
            <FormattedMessage id={item.title} defaultMessage={item.title} />
            {item.createFolder && !props.collapse && props.authUserData?.id ? (
              <Tooltip title={props.tr['Create folder']}>
                <img
                  src={folder_add}
                  alt=""
                  className={CreateFolder}
                  onClick={
                    props.disabled ? null : () => setAddFolderVisible(true)
                  }
                  aria-hidden
                />
              </Tooltip>
            ) : null}
          </Link>
        ),
        key: item.id,
        icon: allIcon[item.icon],
        className: item.title,
      };

      if (item.items && item.items.length > 0) {
        data.className = `mainSubMenuMenu ${item.title}`;
        data.children = createSubMenu(item.items, {
          folders,
          folderTours,
          folderToursCount,
          addFolderVisible,
          setAddFolderVisible,
          foldersPlace,
          folderPlaces,
          folderPlacesCount,
          myPlacesCount,
          folderListDenmark,
          folderListFrance,
          folderListGermany,
          ...props,
        });
        if (item.id === '40' || item.id === '2') {
          data.label = null;
          data.className = 'empty_main_item';
        } else {
          data.label = (
            <FormattedMessage id={item.title} defaultMessage={item.title} />
          );
        }
      }

      if (item.id === '1') {
        data.label = (
          <Link to={getLink(item.url, item.id)}>
            <FormattedMessage id={item.title} defaultMessage={item.title} />
            <div className="ant-menu-submenu-arrow-layout">
              <i className={getDreamArrowClass} />
            </div>
          </Link>
        );
        data.className = `${item.title} main_menu_folder`;
      }

      if (item.id === '4') {
        data.label = (
          <Link to={getLink(item.url, item.id)}>
            <FormattedMessage id={item.title} defaultMessage={item.title} />
            {props.authUserData?.id && item.id === '4' ? (
              <TourCounter count={tourCounterMain} />
            ) : null}
            {item.createFolder && !props.collapse && props.authUserData?.id ? (
              <Tooltip title={props.tr['Create folder']}>
                <img
                  src={folder_add}
                  alt=""
                  className={CreateFolder}
                  onClick={
                    props.disabled
                      ? null
                      : (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          props.openMyFoldersFc(true);
                          setAddFolderVisible(true);
                        }
                  }
                  aria-hidden
                />
              </Tooltip>
            ) : null}
            {folders?.length > 0 ? (
              <div className="ant-menu-submenu-arrow-layout">
                <i className={getArrowClass} />
              </div>
            ) : null}
          </Link>
        );
        data.className = `${item.title} main_menu_folder`;
      }

      if (item.id === '7' && !props.collapse) {
        data.label = (
          <FriendsSelect
            authUser={props.authUserData}
            getFriendToursShortInfoById={(val, id) => {
              props.uploadFriendTourById(id);
            }}
          />
        );
        data.className = `custom ${item.title}`;
      }

      if (item.id === '7' && props.collapse) {
        return;
      }

      items.push(data);
    }
  });

  return items;
};

const NewMainMenu = (props) => {
  const {
    collapse,
    mainMenuCollapse,
    defaultOpenKeys,
    selectedKeys,
    onSelect,
    onOpenChange,
    openKeys,
    openDelay,
    dataMainMenu,
    isFullHeight,
    onClickFc,
  } = props;

  const getClass = () =>
    collapse ? 'menuMainLayout collapse' : 'menuMainLayout';

  const fullMainHeight = isFullHeight ? { height: '100%' } : {};

  return (
    <div className={getClass()} style={fullMainHeight}>
      <div className="menuScrollLayout" style={fullMainHeight}>
        <div className="mainMenuLayout" style={fullMainHeight}>
          <Menu
            mode="inline"
            theme="light"
            defaultOpenKeys={defaultOpenKeys}
            selectedKeys={selectedKeys}
            onSelect={onSelect}
            onOpenChange={onOpenChange}
            openKeys={openKeys}
            inlineCollapsed={collapse}
            subMenuOpenDelay={openDelay()}
            items={createMenu(dataMainMenu, props)}
            onClick={onClickFc}
          />
        </div>
        <SocialBtn collapse={collapse} />
        <CollapseBtn
          isTable={props.isTable}
          collapse={collapse}
          mainMenuCollapse={mainMenuCollapse}
        />
      </div>
      <SwitchMapList {...props} />
    </div>
  );
};

NewMainMenu.displayName = 'NewMainMenu';

export default React.memo(withTranslations(NewMainMenu));
